<div class="flex flex-col items-start flex-row">
  <button id="btn-open-camera" type="button" [disabled]="disabled"
  class="btn-icon-only ui-btn-delete btn-icon icon-camera" (click)="openCameraScanner()"></button>
</div>

<p-confirmDialog key="camera-dialog" styleClass="scanner-modalbox">
  <ng-template pTemplate="message">
    <div class="center-camera w-100">
      @if (isCameraScannerVisible) {
        <app-single-scanner (qrCodeScanned)="onQRCodeScanned($event)">
        </app-single-scanner>
      }
    </div>
  </ng-template>
  <ng-template pTemplate="footer"></ng-template>
</p-confirmDialog>
